import { Component, OnInit, ChangeDetectionStrategy, Inject, ChangeDetectorRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LgvCompanyService } from '../../core/services/lgv-company.service';

@Component({
    selector: 'lus-activity-modal',
    templateUrl: './activity-modal.component.html',
    styleUrls: ['./activity-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ActivityModalComponent implements OnInit {

    constructor(public dialogRef: MatDialogRef<ActivityModalComponent>,
        public lgvCompanySvc: LgvCompanyService,
        private cd: ChangeDetectorRef,
        @Inject(MAT_DIALOG_DATA) public data: any) { }

    ngOnInit() {
        this.cd.detectChanges();
    }
    onNoClick(): void {
        this.dialogRef.close();
    }

}
